import { render, staticRenderFns } from "./OrderMaintenance.vue?vue&type=template&id=385f8d48&scoped=true&"
import script from "./OrderMaintenance.vue?vue&type=script&lang=js&"
export * from "./OrderMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f8d48",
  null
  
)

export default component.exports